(() => {
  const key = 'rc-space-door-entered-v1';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const stage = root.querySelector('[data-door-stage]');
    const enter = root.querySelector('[data-door-enter]');
    const skip = root.querySelector('[data-door-skip]');
    const replay = root.querySelector('[data-door-replay]');
    const hint = root.querySelector('[data-door-hint]');
    const fallback = root.querySelector('[data-door-fallback]');
    const leaf = root.querySelector('[data-door-leaf]');
    const canvas = root.querySelector('[data-door-canvas]');
    if (!stage || !enter || !skip || !replay || !hint || !fallback || !leaf || !canvas) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const gsap = window.gsap;
    let phase = 'idle', engine, timeline, token = 0, safety, previousFocus, previousOverflow, protectedNodes = [];
    function finish() {
      if (phase === 'idle') return;
      phase = 'idle'; token++;
      clearTimeout(safety);
      timeline?.kill(); timeline = null;
      engine?.dispose(); engine = null;
      stage.hidden = true;
      stage.classList.remove('has-scene', 'is-entering');
      document.documentElement.classList.remove('rc-door-active');
      document.body.style.overflow = previousOverflow;
      protectedNodes.forEach(([node, value]) => { node.inert = value; });
      protectedNodes = [];
      try { sessionStorage.setItem(key, 'true'); } catch (_) { }
      if (stage.contains(document.activeElement)) {
        if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({ preventScroll: true });
        else replay.focus({ preventScroll: true });
      }
      root.dispatchEvent(new CustomEvent('rc:intro:end', { bubbles: true }));
    }
    async function loadScene(current) {
      try {
        const threeUrl = new URL(root.dataset.three, document.baseURI).href;
        const sceneUrl = new URL(root.dataset.scene, document.baseURI).href;
        const [THREE, module] = await Promise.all([import(threeUrl), import(sceneUrl)]);
        if (current !== token || phase !== 'waiting') return;
        const created = await module.createDoorScene(THREE, canvas, new URL(root.dataset.doorImage, document.baseURI).href);
        if (current !== token || phase !== 'waiting') { created.dispose(); return; }
        engine = created;
        stage.classList.add('has-scene');
      } catch (_) { }
    }
    function show() {
      finish();
      if (!root.isConnected || document.hidden || document.querySelector('dialog[open]')) return;
      phase = 'waiting'; token++;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      protectedNodes = [...document.querySelectorAll('#PageContainer, #shopify-section-header, [data-rc-newsletter]')].map(node => [node, node.inert]);
      protectedNodes.forEach(([node]) => { node.inert = true; });
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('rc-door-active');
      stage.hidden = false;
      stage.dataset.phase = 'waiting';
      enter.disabled = false;
      hint.hidden = false;
      stage.style.opacity = '1'; stage.style.visibility = 'visible';
      if (gsap) {
        gsap.set(fallback, { scale: 1 });
        gsap.set(leaf, { rotationY: 0 });
        gsap.set(hint, { autoAlpha: 1 });
      }
      enter.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent('rc:intro:start', { bubbles: true }));
      loadScene(token);
    }
    function fly() {
      if (phase !== 'waiting') return;
      phase = 'entering'; token++;
      stage.dataset.phase = 'entering';
      stage.classList.add('is-entering');
      enter.disabled = true;
      if (motion.matches || !gsap) { finish(); return; }
      timeline = gsap.timeline({ defaults: { ease: 'power2.inOut' }, onComplete: finish });
      timeline.to(hint, { autoAlpha: 0, duration: .18 }, 0);
      if (engine) engine.enter(timeline);
      else {
        timeline.to(leaf, { rotationY: -112, duration: .78, ease: 'power3.inOut' }, 0)
          .to(fallback, { scale: 9, duration: 1.8, ease: 'power3.in' }, .34);
      }
      timeline.to(stage, { autoAlpha: 0, duration: .38, ease: 'power1.in' }, 1.85);
      safety = setTimeout(finish, 4500);
    }
    function keyboard(event) {
      if (phase === 'idle') return;
      if (event.key === 'Escape') { event.preventDefault(); finish(); }
      if (event.key === 'Tab') {
        const buttons = [...stage.querySelectorAll('button')].filter(button => !button.disabled && !button.hidden);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }
    function resize() { engine?.resize(); }
    function hidden() { if (document.hidden && phase === 'entering') finish(); }
    function reduce() { if (motion.matches && phase === 'entering') finish(); }
    enter.addEventListener('click', fly);
    skip.addEventListener('click', finish);
    replay.addEventListener('click', show);
    canvas.addEventListener('webglcontextlost', finish);
    document.addEventListener('keydown', keyboard);
    document.addEventListener('visibilitychange', hidden);
    window.addEventListener('resize', resize, { passive: true });
    motion.addEventListener('change', reduce);
    let seen = false;
    try { seen = sessionStorage.getItem(key) === 'true'; } catch (_) { }
    const forced = new URLSearchParams(location.search).get('intro') === '1';
    if (!window.Shopify?.designMode && (forced || !seen) && window.scrollY < 40 && !document.querySelector('[data-newsletter-state]')) show();
    root.addEventListener('rc-door:destroy', () => {
      finish();
      enter.removeEventListener('click', fly); skip.removeEventListener('click', finish); replay.removeEventListener('click', show);
      document.removeEventListener('keydown', keyboard); document.removeEventListener('visibilitychange', hidden);
      window.removeEventListener('resize', resize); motion.removeEventListener('change', reduce);
      stage.querySelector('[data-rc-starfield]')?.dispatchEvent(new Event('rc-starfield:destroy'));
    }, { once: true });
  }
  document.querySelectorAll('[data-rc-door]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rc-door]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rc-door]').forEach(root => root.dispatchEvent(new Event('rc-door:destroy'))));
})();
